import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import IntakeFormNew from './pages/IntakeFormNew';
import CoachSelection from './pages/CoachSelection';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<IntakeFormNew />} />
        <Route path="/selection/:requestId" element={<CoachSelection />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
